const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/ConfirmationDialog/ConfirmationDialogActions.tsx';
import * as React from 'react';
import { ReactNode } from 'react';
import { cx } from '@emotion/css';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';
import { ActionType } from '@cistec/common_web/components/defs';
import { Knopf, KnopfType } from '@cistec/common_web/components/Knopf/Knopf';
import commonTextMap from '@cistec/common_web/translations/translations_common';
import { Footer } from '@cistec/common_web/components/Footer/Footer';
import { FooterGap } from '@cistec/common_web/components/Footer/FooterGap';

interface ConfirmationDialogActionsProps {
    cancelText?: TextInput;
    className?: string;
    confirmActionType?: ActionType;
    confirmButtonType?: KnopfType;
    confirmDisabled?: boolean;
    confirmText?: TextInput;
    left?: ReactNode;
    onBeforeConfirm?: () => boolean;
    onClose?: (confirm: boolean) => void;
    right?: ReactNode;
}

export const ConfirmationDialogActions = (props: ConfirmationDialogActionsProps) => {
    const { confirmActionType, confirmButtonType, confirmDisabled = false, left, onClose, right } = props;

    const confirmText = useText(props.confirmText ?? commonTextMap.actionConfirm);
    const cancelText = useText(props.cancelText ?? commonTextMap.actionCancel);

    const onBeforeConfirm = props.onBeforeConfirm ?? (() => true);

    const cancel = () => {
        onClose?.(false);
    };

    const confirm = () => {
        if (onBeforeConfirm()) {
            onClose?.(true);
        }
    };

    const renderCancelButton = () => {
        if (!cancelText) return null;

        return <Knopf type="text" text={cancelText} do={cancel} />;
    };

    const renderConfirmButton = () => {
        if (!confirmText) return null;

        return (
            <Knopf
                text={confirmText}
                do={confirm}
                actionType={confirmActionType}
                type={confirmButtonType}
                disabled={confirmDisabled}
            />
        );
    };

    const cancelButton = renderCancelButton();
    const confirmButton = renderConfirmButton();

    if (!cancelButton && !confirmButton && !left && !right) return null;

    return (
        <Footer className={cx('ConfirmationDialogActions', props.className)} type="secondary">
            {left}
            <FooterGap />
            {right}
            {renderCancelButton()}
            {renderConfirmButton()}
        </Footer>
    );
};